import * as Style from './ScoreRadioGroup.style';

interface ScoreRadioGroupProps {
  $color: string;
  [key: string]: unknown;
}

const ScoreRadioGroup = ({ $color, ...rest }: ScoreRadioGroupProps) => {
  const returnClassName = (index: number) => {
    switch (index) {
      case 0:
        return 'score-radio-option-first';
      case 2:
        return 'score-radio-option-middle';
      case 5:
        return 'score-radio-option-last';
      default:
        return '';
    }
  };

  const options = Array.from({ length: 6 }, (_, i) => ({
    label: i.toString(),
    value: i.toString(),
    className: returnClassName(i),
  }));

  return <Style.RadioGroup $color={$color} options={options} {...rest} />;
};

export default ScoreRadioGroup;
